var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3077 16.8846C2.80898 16.8846 2.38302 16.7079 2.02982 16.3547C1.67661 16.0015 1.5 15.5756 1.5 15.0769V2.38458H0.5V0.884599H4.99997V0H11V0.884599H15.5V2.38458H14.5V15.0769C14.5 15.582 14.325 16.0096 13.975 16.3596C13.625 16.7096 13.1974 16.8846 12.6922 16.8846H3.3077ZM13 2.38458H2.99997V15.0769C2.99997 15.1666 3.02882 15.2403 3.08652 15.298C3.14422 15.3557 3.21795 15.3846 3.3077 15.3846H12.6922C12.7692 15.3846 12.8397 15.3525 12.9038 15.2884C12.9679 15.2243 13 15.1538 13 15.0769V2.38458ZM5.40385 13.3846H6.90382V4.38458H5.40385V13.3846ZM9.09613 13.3846H10.5961V4.38458H9.09613V13.3846Z",
    fill: "#505D69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.f8a411eabf9f6387e06dbcd610458b48.svg";
export { ForwardRef as ReactComponent };